import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function ConditiiStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Toggle
        label="Penalizari de intarziere"
        description="Se aplica penalizari pentru intarzierea la plata"
        checked={!!data.penalizareActiva}
        onChange={() => update("penalizareActiva")(!data.penalizareActiva)}
      />
      {data.penalizareActiva && (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            <SelectField
              label="Penalizare (% pe zi de intarziere)"
              value={data.penalizare}
              onChange={update("penalizare")}
              options={[
                { value: "0.05", label: "0,05% / zi" },
                { value: "0.1", label: "0,1% / zi" },
                { value: "0.15", label: "0,15% / zi" },
                { value: "0.2", label: "0,2% / zi (maxim legal recomandat)" },
              ]}
              half
            />
          </div>
          <p style={{ fontSize: "12px", color: "#8a7e70", margin: 0, fontStyle: "italic" }}>
            Penalitatile se aplica la suma restanta si nu pot depasi cuantumul acesteia.
          </p>
        </div>
      )}

      <Toggle
        label="Fidejusiune (garant)"
        description="O persoana fizica garanteaza restituirea imprumutului"
        checked={!!data.garantieActiva}
        onChange={() => update("garantieActiva")(!data.garantieActiva)}
      />
      {data.garantieActiva && (
        <p style={{ fontSize: "11px", color: "#8a7e70", margin: "0 0 4px 0" }}>
          Garantul poate fi urmarit direct pentru plata in cazul neexecutarii.
        </p>
      )}
      {data.garantieActiva && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginTop: "8px", padding: "16px", backgroundColor: "#fdfbf7", borderRadius: "8px", border: "1px solid #e8e0d4" }}>
          <InputField label="Nume complet garant" value={data.garantNume} onChange={update("garantNume")} placeholder="ex: Ionescu Maria" required error={errors.garantNume} />
          <InputField label="Adresa garant" value={data.garantAdresa} onChange={update("garantAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.garantAdresa} />
          <OptionalFields>
            <InputField label="CNP garant" value={data.garantCNP} onChange={update("garantCNP")} placeholder="ex: 2850101123456" half error={errors.garantCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI garant" value={data.garantCI} onChange={update("garantCI")} placeholder="ex: RD 123456" half error={errors.garantCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
          <div style={{ width: "100%" }}>
            <Toggle
              label="Raspundere solidara"
              description="Garantul raspunde alaturi de Imprumutat pentru intreaga suma (recomandat)"
              checked={data.garantSolidar !== false}
              onChange={() => update("garantSolidar")(!data.garantSolidar)}
            />
            {data.garantSolidar === false && (
              <p style={{ fontSize: "12px", color: "#c45d3e", margin: "8px 0 0 0", fontStyle: "italic" }}>
                ⚠️ Fara raspundere solidara, creditorul trebuie sa il urmareasca mai intai pe imprumutat.
              </p>
            )}
          </div>
        </div>
      )}

      <Toggle
        label="Martori"
        description="Contractul va include sectiune de semnaturi pentru 2 martori"
        checked={!!data.martori}
        onChange={() => update("martori")(!data.martori)}
      />
      {data.martori && (
        <p style={{ fontSize: "12px", color: "#8a7e70", margin: "0 0 0 0", fontStyle: "italic" }}>
          Martorii confirma semnarea contractului, dar nu transforma documentul in titlu executoriu.
        </p>
      )}
    </div>
  );
}
